export const card = 'bg-white rounded-xl shadow p-6';

export const field =
  'w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500';

// mt-auto: в карточке-flex-колонке кнопка уходит к нижнему краю,
// поэтому карточки одного ряда сетки выглядят одинаково
export const primaryBtn =
  'w-full mt-auto bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-semibold disabled:opacity-50';

// карточка-секция с якорем; flex-col + gap вместо space-y, чтобы работал mt-auto
export const sectionClass = (id, highlightedId, gap = 'gap-4') =>
  `${card} flex flex-col ${gap} transition-all scroll-mt-16 ${highlightedId === id ? 'ring-2 ring-blue-400' : ''}`;